[
  {
    "name": "Albania",
    "language": "Albanian",
    "code": "AL"
  },
  {
    "name": "Andorra",
    "language": "Catalan",
    "code": "AD"
  },
  {
    "name": "Austria",
    "language": "German",
    "code": "AT"
  },
  {
    "name": "Belarus",
    "language": "Belarusian",
    "code": "BY"
  },
  {
    "name": "Belgium",
    "language": "Dutch, French, German",
    "code": "BE"
  },
  {
    "name": "Bosnia and Herzegovina",
    "language": "Bosnian, Serbian, Croatian",
    "code": "BA"
  },
  {
    "name": "Bulgaria",
    "language": "Bulgarian",
    "code": "BG"
  },
  {
    "name": "Croatia",
    "language": "Croatian",
    "code": "HR"
  },
  {
    "name": "Cyprus",
    "language": "Greek, Turkish",
    "code": "CY"
  },
  {
    "name": "Czech Republic",
    "language": "Czech",
    "code": "CZ"
  },
  {
    "name": "Denmark",
    "language": "Danish",
    "code": "DK"
  },
  {
    "name": "Estonia",
    "language": "Estonian",
    "code": "EE"
  },
  {
    "name": "Finland",
    "language": "Finnish, Swedish",
    "code": "FI"
  },
  {
    "name": "France",
    "language": "French",
    "code": "FR"
  },
  {
    "name": "Germany",
    "language": "German",
    "code": "DE"
  },
  {
    "name": "Greece",
    "language": "Greek",
    "code": "GR"
  },
  {
    "name": "Hungary",
    "language": "Hungarian",
    "code": "HU"
  },
  {
    "name": "Iceland",
    "language": "Icelandic",
    "code": "IS"
  },
  {
    "name": "Ireland",
    "language": "Irish, English",
    "code": "IE"
  },
  {
    "name": "Italy",
    "language": "Italian",
    "code": "IT"
  },
  {
    "name": "Kosovo",
    "language": "Albanian, Serbian",
    "code": "XK"
  },
  {
    "name": "Latvia",
    "language": "Latvian",
    "code": "LV"
  },
  {
    "name": "Liechtenstein",
    "language": "German",
    "code": "LI"
  },
  {
    "name": "Lithuania",
    "language": "Lithuanian",
    "code": "LT"
  },
  {
    "name": "Luxembourg",
    "language": "Luxembourgish, French, German",
    "code": "LU"
  },
  {
    "name": "Macedonia",
    "language": "Macedonian",
    "code": "MK"
  },
  {
    "name": "Malta",
    "language": "Maltese, English",
    "code": "MT"
  },
  {
    "name": "Moldova",
    "language": "Romanian",
    "code": "MD"
  },
  {
    "name": "Monaco",
    "language": "French",
    "code": "MC"
  },
  {
    "name": "Montenegro",
    "language": "Montenegrin",
    "code": "ME"
  },
  {
    "name": "Netherlands",
    "language": "Dutch",
    "code": "NL"
  },
  {
    "name": "Norway",
    "language": "Norwegian",
    "code": "NO"
  },
  {
    "name": "Poland",
    "language": "Polish",
    "code": "PL"
  },
  {
    "name": "Portugal",
    "language": "Portuguese",
    "code": "PT"
  },
  {
    "name": "Romania",
    "language": "Romanian",
    "code": "RO"
  },
  {
    "name": "Russia",
    "language": "Russian",
    "code": "RU"
  },
  {
    "name": "San Marino",
    "language": "Italian",
    "code": "SM"
  },
  {
    "name": "Serbia",
    "language": "Serbian",
    "code": "RS"
  },
  {
    "name": "Slovakia",
    "language": "Slovak",
    "code": "SK"
  },
  {
    "name": "Slovenia",
    "language": "Slovenian",
    "code": "SI"
  },
  {
    "name": "Spain",
    "language": "Spanish",
    "code": "ES"
  },
  {
    "name": "Sweden",
    "language": "Swedish",
    "code": "SE"
  },
  {
    "name": "Switzerland",
    "language": "German, French, Italian, Romansh",
    "code": "CH"
  },
  {
    "name": "Ukraine",
    "language": "Ukrainian",
    "code": "UA"
  },
  {
    "name": "United Kingdom",
    "language": "English",
    "code": "EN"
  },
  {
    "name": "Vatican City",
    "language": "Italian, Latin, French",
    "code": "VA"
  }
]